import { FC, ReactNode, useCallback } from 'react';
import titleCss from './assets/title.module.scss';
import { useClassNamesWithStyle } from '#base/hooks';

type PropsType = {
  title: ReactNode|null;
  uppercase?: boolean;
  textCenter?: boolean;
  sizeLg?: boolean;
  isDisplayAsH1?: boolean;
  additionalClassName?: string;
  withMarginBottom?: boolean;
};

const Title: FC<PropsType> = ({
  title,
  uppercase = true,
  textCenter = true,
  sizeLg = false,
  isDisplayAsH1 = false,
  additionalClassName = null,
  withMarginBottom = false,
}) => {
  const classNamesWithStyle = useClassNamesWithStyle();

  const buildClassName = useCallback(() => classNamesWithStyle(
    [
      titleCss.title,
      { [titleCss.title_uppercase]: uppercase },
      { [titleCss.title_textCenter]: textCenter },
      { [titleCss.title_sizeLg]: sizeLg },
      { [titleCss.title_withMarginBottom]: withMarginBottom },
      additionalClassName,
    ],
    titleCss.title_styleDefault,
    titleCss.title_styleRed,
  ), [additionalClassName, classNamesWithStyle, sizeLg, textCenter, uppercase, withMarginBottom]);

  if (!title) {
    return null;
  }

  if (isDisplayAsH1) {
    return (
      <h1 className={buildClassName()}>
        {title}
      </h1>
    );
  }

  return (
    <h2 className={buildClassName()}>
      {title}
    </h2>
  );
};

export { Title };
